import { gql } from '@apollo/client/core';

export const CREATE_CONTRACT_DEPOSIT_INFORMATION = gql`
  mutation createContractDepositInformation(
    $input: CreateContractDepositInformationInput!
  ) {
    createContractDepositInformation(input: $input) {
      id
      deposit_platform
      deposit_type
    }
  }
`;
